import { useContext, useState } from "react";
import "./styles.css";
import api from "../../../services/axiosConfig";
import Swal from "sweetalert2";
import FullScreenLoader from "../../../components/FullScreenLoader/FullScreenLoader";
import { Context } from "../../../hooks/useAuthContext";

function RecuperarSenha() {
  const { exibirLogs } = useContext(Context);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsButtonDisabled(true);

    try {
      await api.post("/recovery/enviar-codigo", { email });
    } catch (error) {
      exibirLogs && console.error("Erro ao enviar código:", error);
    } finally {
      setLoading(false);

      Swal.fire({
        text: "Se o email informado existir, você receberá o link para alterar sua senha. O email com o código pode demorar de 1 a 5 minutos, caso não chegue, entre em contato com o suporte.",
        icon: "success",
      });

      // Reabilita o botão após 10 segundos
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 10000);
    }
  };

  return (
    <div className="wrapper">
      {loading && <FullScreenLoader />}
      <div className="recuperarSenha">
        <div className="logoRecuperarSenha">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>

        <div className="formRecuperacao">
          <span className="titleTextRecuperar">Recuperar senha</span>

          <form className="form" style={{ marginTop: 20 }}>
            <div className="formGroup">
              <label htmlFor="email">Informe seu email</label>
              <input
                id="email"
                className="inputForm"
                type="email"
                placeholder="Digite aqui"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              type="submit"
              onClick={(e) => handleSubmit(e)}
              disabled={isButtonDisabled}
              style={{
                marginTop: 15,
                opacity: isButtonDisabled ? 0.6 : 1,
                cursor: isButtonDisabled ? "not-allowed" : "pointer",
              }}
            >
              Enviar código
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RecuperarSenha;
